/**
 * Maps a GetStarted submission to the best-fit service + pricing tier.
 * Used to auto-route leads from /systems/get-started to the right pricing page.
 */

const INTEREST_TO_SLUG = {
  'Managed IT Services': 'managed-it-services',
  'Infrastructure Services': 'it-infrastructure-deployment',
  'Cybersecurity Services': 'cybersecurity-support',
  'IT Consulting & Advisory': 'it-consulting-technology-advisory',
};

const DEVICES_TO_TIER = {
  '1 - 5': 'essential',
  '6 - 20': 'essential',
  '21 - 50': 'professional',
  '51 - 200': 'enterprise',
  '200+': 'enterprise',
};

export function recommendPlan({ setup, interest, devices }) {
  const slug = INTEREST_TO_SLUG[interest] || 'managed-it-services';

  // Setup overrides device mapping when it's an unambiguous signal.
  let tierId;
  if (setup === 'individual') {
    tierId = 'essential';
  } else if (setup === 'enterprise') {
    tierId = 'enterprise';
  } else {
    tierId = DEVICES_TO_TIER[devices] || 'professional';
  }

  return {
    slug,
    tierId,
    url: `/systems/solutions/${slug}/pricing?highlight=${tierId}&from=get-started`,
  };
}
